import React, { Component, Fragment } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { dataFormatters } from "../../../../utils/dataFormatters";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import { DataPropertyRow } from "../../../../libraries/ReportGenerator/DataPropertyRow";

const structureConditionOptions = ["Poor", "", "Fair", "", "Good", ""];
const yesNoOptions = ["Yes", "", "No", "", "", ""];
const derailType = ["Hinge", "Switch Point", "Sliding", "Other", ""];
const selectOne = ["Left Hand", "", "Right Hand", "", "Both", ""];
const secureTies = ["Spiked", "", "Lagged", "", "", ""];

const SectionHeader = ({ title }) => {
  return <div style={{ padding: "5px", textAlign: "left", fontSize: "18px", fontWeight: 600 }}>{title}</div>;
};

class ReportView extends Component {
  render() {
    let reportData = this.props.reportData ? this.props.reportData : {};
    let { milepost, location, user, date, formSummary, subdivision } = reportData;
    if (!formSummary) formSummary = {};

    let data = {
      lineName: subdivision,
      location: location,
      user: user ? user.name : "",
      milepost: milepost,
      reportDate: dataFormatters.dateFormatter(date),
      ...formSummary,
    };

    return (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection
          title={`Derail Inspection (Annual)`}
          displayRevisedAreaText={"Revised: June 1, 2010"}
          fontSizeOverride={"28px"}
        />
        <ReportInfoSection
          fontSizeOverride={"18px"}
          rows={[
            {
              col1: {
                title: "Inspector",
                value: data.user,
              },
              col2: {
                title: "Date",
                value: data.reportDate,
              },
            },
            {
              col1: {
                title: "Derail Location",
                value: data.location,
              },
              col2: {
                title: "Subdivision",
                value: data.lineName,
              },
            },
          ]}
        />
        <span className="spacer"></span>
        <DataPropertyRow title={"Derail Type"} id={"dtype"} data={data} options={derailType} otherValId={"open"} />
        <span className="spacer"></span>
        <ReportInfoSection
          fontSizeOverride={"18px"}
          rows={[
            {
              col1: {
                title: "Derail Size",
                value: data.dsize,
              },
              col2: {
                title: "Lock Condition",
                value: data.cond,
              },
            },
          ]}
        />
        <span className="spacer"></span>
        <DataPropertyRow title={"Select One"} id={"sone"} data={data} options={selectOne} />
        <DataPropertyRow title={"Securement to Ties"} id={"ties"} data={data} options={secureTies} />
        <DataPropertyRow title={"Tie Condition"} id={"tcond"} data={data} options={structureConditionOptions} />
        <DataPropertyRow title={"Handle on Derail"} id={"hand"} data={data} options={yesNoOptions} />
        <DataPropertyRow title={"Derail Sign"} id={"sign"} data={data} options={yesNoOptions} />
        <DataPropertyRow title={"Derail Target"} id={"targ"} data={data} options={yesNoOptions} />
        <DataPropertyRow title={"Overall Derail Condition"} id={"tcond1"} data={data} options={structureConditionOptions} />
        <SectionHeader title={"Additional Comments"} />
        <div style={{ display: "flex" }}>
          <div style={{ border: "2px solid", padding: "5px", fontSize: "18px", height: "150px", flexGrow: 7 }}>{data.com}</div>
          <div style={{ flexGrow: 2 }}></div>
        </div>
      </div>
    );
  }
}

const ONR_DerailInspectionAnnual = (props) => {
  const { inspec, isPreview } = props;
  if (isPreview) {
    return <ReportView reportData={{}} isPreview={true} />;
  }

  let assets = ReportGeneratorUtils.getInspectionAssetsWithForm(inspec, () => true, "onrDerailInspectionForm");
  return assets.map((asset, _i) => (
    <ReportView
      {...props}
      key={_i}
      reportData={{
        formSummary: asset.summary,
        location: asset.assetName,
        subdivision: ReportGeneratorUtils.getInspectionSubdivision(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
        milepost: asset.milepostWithPrefix,
      }}
    />
  ));
};

export default ONR_DerailInspectionAnnual;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/DerailInspectionAnnual/index.jsx